import cookie from 'cookie'
import { trackGifShare } from '../api'

/**
 * Utility to get state from selectors (which allow the state shape to be hidden)
 * and based on the state, load more gifs and then dispatch the received action
 */
export default (gifId, type) => {
    const csrftoken = cookie.parse(document.cookie).csrftoken
    return trackGifShare(gifId, type, csrftoken)
}
